import { Modal } from "antd";
import React from "react";
import "./style.scss";

const AkoModal = ({ open = false, onClose, children, className = "" }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closeIcon={null}
      centered
      className={className}
    >
      {children}
    </Modal>
  );
};

export default AkoModal;
